import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { FormControl } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';

import Button from '../../../../ui-core/Button/Button';

import './style.css';

function SearchBox(props) {
  const { placeholder, className } = props;
  const history = useHistory();
  const [enteredStr, setEnteredStr] = useState('');
  const { search } = useLocation();

  const query = new URLSearchParams(search);
  const filter = query.get('filter');

  useEffect(() => {
    if (query.get('_q')) {
      setEnteredStr(query.get('_q'));
    }
  }, [query.get('_q')]);

  const handChange = e => {
    const { value } = e.target;
    setEnteredStr(value);
  };

  const handleKeyDown = event => {
    if (event.keyCode === 13) {
      history.push(
        enteredStr.trim()
          ? `/podcasts-listing?${
              filter ? 'filter=' + encodeURIComponent(filter) + '&' : ''
            }_q=${enteredStr.trim()}`
          : `/podcasts-listing${
              filter ? '?filter=' + encodeURIComponent(filter) : ''
            }`,
      );
    }
    if (enteredStr === '' && event.keyCode === 8) {
      history.push(
        enteredStr.trim()
          ? `/podcasts-listing?${
              filter ? 'filter=' + encodeURIComponent(filter) + '&' : ''
            }_q=${enteredStr.trim()}`
          : `/podcasts-listing${
              filter ? '?filter=' + encodeURIComponent(filter) : ''
            }`,
      );
    }
  };

  return (
    <div
      className={clsx(
        'd-flex',
        'header-search',
        'position-relative',
        className,
      )}
    >
      <Button variant="outline-success" />
      <FormControl
        placeholder={placeholder || ''}
        aria-label="Search"
        onChange={handChange}
        onKeyDown={handleKeyDown}
        value={enteredStr}
        className="search-input-box"
      />
      {enteredStr && (
        <span
          className="close-icon"
          onClick={() => {
            if (enteredStr) {
              history.push(
                `/podcasts-listing${
                  filter ? '?filter=' + encodeURIComponent(filter) : ''
                }`,
              );
              setEnteredStr('');
            }
          }}
        >
          &#10006;
        </span>
      )}
    </div>
  );
}

SearchBox.propTypes = {
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

export default SearchBox;
